import { createSelector } from "@reduxjs/toolkit";
import { isCommonFilterGroup } from "../model";
import { activityHistoryFiltersSelector } from "../selectors";

export const activityHistoryCommonFiltersSelector = createSelector(
  activityHistoryFiltersSelector,
  (filters) => filters.find(isCommonFilterGroup)?.filters || [],
);

export const isEnabledCommonFilterSelector = (filterId: string) =>
  createSelector(
    activityHistoryCommonFiltersSelector,
    (filterSpecs) => filterSpecs?.find((s) => s.id === filterId)?.enabled,
  );

export const activityHistoryEnabledCommonFiltersSelector = createSelector(
  activityHistoryCommonFiltersSelector,
  (filters) => filters.filter((f) => f.enabled),
);

export const areCommonFiltersActive = createSelector(
  activityHistoryEnabledCommonFiltersSelector,
  (filters) => !!filters.length,
);
